import React from 'react'
import {
  styled,
  Checkbox as MuiCheckbox,
  FormControlLabel as MuiFormControlLabel,
} from '@material-ui/core'
import {useEditApplication} from 'lms/hooks'
import {SYSTEM_TYPES} from 'lms/constants/systemTypes'

const Content = styled('div')({})

const Heading = styled('h4')(({theme}) => ({
  margin: 0,
  marginTop: 12,
  marginBottom: 6,
  fontSize: 18,
  fontWeight: 500,
  color: theme.palette.text.secondary,
  borderBottom: `1px solid ${theme.palette.divider}`,
}))

const Grid = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
})

const FormControlLabel = styled(MuiFormControlLabel)({
  marginRight: 16,
})

const SystemType = (props) => {
  const [application, updateApplication] = useEditApplication()

  const rawTypes = application.type
  const appTypes = Array.isArray(rawTypes) ? rawTypes : (rawTypes ? [rawTypes] : [])
  const isSelected = value => appTypes.includes(value)

  const updateTypes = (value, checked) => {
    const set = new Set(appTypes)
    checked ? set.add(value) : set.delete(value)
    updateApplication({type: Array.from(set)})
  }

  return (
    <Content {...props}>
      <Heading>Learning System Type</Heading>
      <Grid>
        {SYSTEM_TYPES.map(({value, display}) => (
          <FormControlLabel
            key={value}
            label={display}
            control={
              <MuiCheckbox
                checked={isSelected(value)}
                onChange={(e, checked) => updateTypes(value, checked)}
              />
            }
          />
        ))}
      </Grid>
    </Content>
  )
}

export default SystemType
